<template>
    <div class="dialogTotal">
      <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled">
        <el-form-item v-for="(item,index) in total" :label="item.label" :key="item.name"  v-if="item.type !== 3" :prop="item.name" >
          <el-input v-if="item.type === 0" :name="item.name" v-model="item.value" @blur="item.blur(index)" @change="item.changes(index)" @focus="item.focus(index)" clearable :disabled="item.name === 'caseNumber'"></el-input>
          <div v-if="item.warning === 1" style="position: absolute;margin-top: -10px;margin-left: 5px;color: red;" v-html="item.warningMsg"></div>
          <el-select v-if="item.type === 1"  :name="item.name" v-model="item.value" @blur="item.blur(index)" @change="item.changes(index)" @focus="item.focus(index)"  clearable >
            <el-option v-for="it in item.options" :key="it.value" :label="it.label" :value="it.label"></el-option>
          </el-select>
          <div v-if="item.warning === 1" style="position: absolute;margin-top: -10px;margin-left: 5px;color: red;">{{item.warningMsg}}</div>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
  import bus from './bus'
  import arrayData from '../assets/javascript/dataProcess'
    export default {
      name: "dialogTotal",
      data() {
        return {
          disabled:false,
          totalData:{},
          total:[]
        }
      },
      methods:{
          /*数据渲染*/
          dataRender(){
            for(let i = 0;i < this.total.length;i++){
              for (let key of Object.keys(this.totalData)) {
                if(key === this.total[i].name){
                  this.total[i].value = this.totalData[key];
                }
              }
            }
          },
        /*数据修改*/
        changeData() {
          let formData = {};
          if (this.total[0].value === '' || this.total[1].value === '' || this.total[2].value === '' || this.total[3].value === '' || this.total[4].value === '' || this.total[5].value === '' || this.total[6].value === '' || this.total[7].value === '') {
            for (let i = 0; i < 10; i++) {
              if (this.total[i].value === "") {
                this.$set(this.total[i], "warning", 1);
                this.$set(this.total[i], "warningMsg", "必填信息不得为空");
              }
            }
          } else {
            for (let i = 0; i < this.total.length; i++) {
              formData[this.total[i].name] = this.total[i].value;
            }
            formData.id = this.totalData.id;
            formData.totalId = this.totalData.totalId;
            this.loading = true;
            this.$http.put(
              '/total/total',
              formData, {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
              .then((res) => {
                this.$message({
                  message: "总体信息修改成功",
                  type: 'success',
                  center: true,
                  duration: 1000
                });
                this.$nextTick(
                  this.loading = false,
                );
              })
              .catch((err) => {
                console.log(err);
                this.$nextTick(
                  this.loading = false,
                );
              });
          }
        }
      },
      created(){
        this.total = arrayData.data3.total;
          /*接收数据*/
          bus.$on("total",msg=>{
            this.totalData = msg;
            this.dataRender();
          });
        /*不可以修改*/
        bus.$on("disable", () => {
          this.disabled = true;
        });
        /*可以修改*/
        bus.$on("change", () => {
          this.disabled = false;
        });
      }
    }
</script>

<style scoped>
  .dialogTotal{
    width: 99%;
    height: 100%;
  }
  .formMsg{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content:flex-start;
  }
  .el-form-item{
    width: 33%;
  }
  .el-form-item__content{
    width:calc(100% - 45%);
  }
  .el-input{
    width: 100%;
  }
  .el-select{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/data/dialogTotal.vue